import React from "react";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const MicIcon = ({
  height = normalize(25),
  width = normalize(24),
  color = theme.colors["neutral.900"],
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    {...props}
    viewBox="0 0 25 24"
    preserveAspectRatio="xMidYMin meet"
  >
    <Path
      d="M12.9 14c.796 0 1.559-.324 2.121-.901.563-.577.879-1.36.879-2.176V7.077c0-.816-.316-1.599-.879-2.176A2.962 2.962 0 0 0 12.9 4c-.796 0-1.559.324-2.121.901A3.117 3.117 0 0 0 9.9 7.077v3.846c0 .816.316 1.599.879 2.176A2.962 2.962 0 0 0 12.9 14Zm-1.5-6.923c0-.408.158-.8.44-1.088.28-.288.662-.45 1.06-.45s.78.162 1.06.45c.282.289.44.68.44 1.088v3.846c0 .408-.158.8-.44 1.088-.28.289-.662.45-1.06.45s-.78-.162-1.06-.45a1.559 1.559 0 0 1-.44-1.088V7.077Z"
      fill={color}
    />
    <Path
      d="M18.9 10.833a.822.822 0 0 0-.251-.589.87.87 0 0 0-.606-.244.87.87 0 0 0-.606.244.822.822 0 0 0-.251.59 4.109 4.109 0 0 1-1.255 2.946A4.349 4.349 0 0 1 12.9 15a4.349 4.349 0 0 1-3.03-1.22 4.109 4.109 0 0 1-1.256-2.947.822.822 0 0 0-.25-.589.87.87 0 0 0-.607-.244.87.87 0 0 0-.606.244.822.822 0 0 0-.251.59 5.74 5.74 0 0 0 1.467 3.814 6.05 6.05 0 0 0 3.676 1.952v1.733h-1.809a.774.774 0 0 0-.54.218.731.731 0 0 0-.223.524v.183c0 .197.08.386.224.525.143.139.337.217.54.217h5.33a.774.774 0 0 0 .54-.217.731.731 0 0 0 .224-.525v-.183a.731.731 0 0 0-.224-.524.774.774 0 0 0-.54-.218h-1.808V16.6a6.05 6.05 0 0 0 3.676-1.952 5.74 5.74 0 0 0 1.467-3.815Z"
      fill={color}
    />
  </Svg>
);

export default MicIcon;
